import { useState, useEffect } from "react";
import Table from "../../components/Table/Table";
import { TableSearch } from "../../components/Table/TableActions";
import Modal from "../../components/Modal/index";
import { Icon } from "@iconify/react";
import { httprequest } from "../../data/api";
import { toast, ToastContainer } from "react-toastify";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "../../components/Button/Button";
import { Grid } from "@mui/material";
import Select from "react-select";

// import SelectGroup from "../../components/FormComponent/SelectGroup";
const SCHOOLS_ENDPOINT = "/admin/v1/schools";

const GET_PARTNERS = "/admin/v1/pricing-plan/partners";
const POST_PARTNER = "/admin/v1/pricing-plan/partners/assign-partner";
const REMOVE_ENDPOINT = "/admin/v1/pricing-plan/partners/remove-partner";

const AllEmployees = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [AllPartnerData, setAllPartnerData] = useState([]);
  const [schoolData, setSchoolData] = useState([]);
  const [isDeleting, setIsDeleting] = useState(false);
  const [removePartnersModal, setRemovePartnersModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [currentRow, setCurrentRow] = useState({});

  const handleRmoveModal = (row) => {
    setCurrentRow(row);
    setRemovePartnersModal(true);
  };

  const handleCloseRemoveModal = () => {
    setCurrentRow({});
    setRemovePartnersModal(false);
  };

  const handleOpenCreateModal = () => setCreateModal(true);
  const handleCloseCreateModal = () => {
    setSelectedSchool(null); // reset selection
    setCreateModal(false);
  };

  const [isLoading, setIsLoading] = useState(false);
  // const [currentRow, setCurrentRow] = useState({});

  // eslint-disable-next-line no-console
  console.log("AllPartnerData", AllPartnerData);

  const getAllSchools = () => {
    httprequest.get(SCHOOLS_ENDPOINT).then((res) => {
      setSchoolData(res?.data?.data?.schools);
    }).catch((err) => {
      toast.error(err?.response?.data);
    });
  };

  const getPartnerData = () => {
    httprequest
      .get(GET_PARTNERS)
      .then((res) => {
        setAllPartnerData(res?.data?.data || []);
        setSearchResult(res?.data?.data || []);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  const handleFinalDelete = () => {
    setIsDeleting(true);
    httprequest
      .delete(REMOVE_ENDPOINT, {
        data: { school_id: currentRow?.school_id }
      })
      .then(() => {
        toast.success("School successfully removed");
        handleCloseRemoveModal();
        getPartnerData();
      })
      .catch(() => {
        toast.error("Failed to delete school");
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  const handleAddPartner = () => {
    if (!selectedSchool) {
      toast.error("Please select a school");

      return;
    }

    setIsLoading(true);

    httprequest
      .post(POST_PARTNER, { school_id: selectedSchool.value })
      .then(() => {
        toast.success("Partner added successfully!");
        getPartnerData(); // refresh partner list
        handleCloseCreateModal();
      })
      .catch((err) => {
        toast.error(err?.response?.data || "Failed to add partner");
      }).finally(() => {
        setIsLoading(false); // stop loading
      });
  };

  const columns = [
    // {
    //   name: "Code",
    //   selector: row => row?.code
    // },
    {
      name: "Name",
      // eslint-disable-next-line prefer-template
      selector: (row) => row?.school_name
    },
    {
      name: "Email Address",
      selector: (row) => row?.email
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row, index) => (
        <div key={index} className="table-action-container">
          <button
            className="table-action-icon"
            key={row.school_id}
            onClick={() => handleRmoveModal(row)}
          >
            {/* {row?.is_active === true ? (
              <div className="delete-icon">
                <Icon icon="mingcute:delete-2-line" />
              </div>
            ) : (
              <div className="approve-icon">
                <Icon icon="mdi:checkbox-marked-circle-outline" />
              </div>
            )} */}
            <div className="delete-icon">
              <Icon icon="mingcute:delete-2-line" />
            </div>
          </button>
        </div>
      )
    }
  ];

  // --| Filter Teacher table using name, email and class
  const handleSearchTeacher = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = AllPartnerData?.filter((data) => valArray?.every(
      (word) => data?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.last_name?.toLowerCase().includes(word.toLowerCase()) ||
          data?.email?.toLowerCase().includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  useEffect(() => {
    getPartnerData();
    setSearchResult();
    getAllSchools();
  }, []);

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Partner"
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                subtitle="See list of partner"
                onClick={handleOpenCreateModal}
                buttonName={
                  <div className="flex align-items-center gap-5">
                    <span>
                      <AddCircleOutlineIcon />
                    </span>
                    Add a new Partner
                  </div>
                }
              />
            }
          />
          <Table
            data={searchResult}
            columns={columns}
            subHeader={true}
            pagination
            subHeaderComponent={
              <TableSearch
                placeholder="Search here..."
                searchTableFunc={handleSearchTeacher}
              />
            }
          />
          <Modal
            title="Add Partner"
            subtitle={<div>Add this school to your partner.</div>}
            modalContent={
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Select
                    options={schoolData.map((school) => ({
                      value: school.school_id,
                      label: school.school_name
                    }))}
                    value={selectedSchool}
                    onChange={setSelectedSchool}
                    placeholder="Select a school..."
                    closeMenuOnSelect={true}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                  />
                </Grid>
              </Grid>

            }
            modalFooter={
              <>
                <Button
                  variant="primary"
                  buttonName="Add Partner"
                  buttonSize="full"
                  color="btndefault"
                  onClick={handleAddPartner}
                  isLoading={isLoading}
                />
              </>
            }
            isopen={createModal}
            closeModal={handleCloseCreateModal}
          />
          {/* Remove Partner */}
          <Modal
            title="Remove Partner"
            subtitle={
              <div>
                            You are about remove <span className="modal-name-highlight">{currentRow?.school_name}</span>. This will revoke all premium access to Shelf21 services
                            as partners. Owned by {`${currentRow?.user?.first_name} ${currentRow?.user?.last_name}`}.
              </div>
            }
            modalContent={
              <div style={{ color: "red", fontWeight: "bold", margin: "20px 0" }}>
                            Are you absolutely sure you want to proceed?
              </div>
            }
            modalFooter={
              <div>
                <Button
                  variant="danger"
                  buttonName="Remove School"
                  buttonSize="full"
                  color="btndefault"
                  isLoading={isDeleting}
                  onClick={handleFinalDelete}
                />
              </div>
            }
            isopen={removePartnersModal}
            closeModal={handleCloseRemoveModal}
          />
          <ToastContainer />
        </>
      }
    />
  );
};

export default AllEmployees;
